<div id="login" class="login-container">
    <mat-card class="login-card-container">
        <mat-card-content>
            <div id="login-title-container" class="login-title-container">
                <span>
                    To begin the online questionnaire, please enter the following information listed on the front of the letter you recently received.
                </span>
            </div>
            <form [formGroup]="Form" (ngSubmit)="OnSubmit()">
                <div id="login-form-title-container">
                    <div id="login-form-content" class="tile-content">
                        <enterprise-text-input  [InputId]="'reference-number'"
                                                [InputName]="'referenceNumber'"
                                                #ReferenceNumber
                                                Label="Reference Number"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('referenceNumber', 'Reference Number')"
                                                formControlName="referenceNumber"
                                                [MaxLength]="ReferenceNumberMaxLength"
                                                [Appearance]="'outline'">
                        </enterprise-text-input>
                        <enterprise-text-input  [InputId]="'last-name'"
                                                [InputName]="'lastName'"
                                                #LastName
                                                Label="Patient's Last Name"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('lastName', 'Patient\'s Last Name')"
                                                formControlName="lastName"
                                                [MaxLength]="LastNameMaxLength"
                                                [Appearance]="'outline'">
                        </enterprise-text-input>
                        <enterprise-text-input  [InputId]="'zip-code'"
                                                [InputName]="'zipCode'"
                                                #ZipCode
                                                Label="Zip Code"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('zipCode', 'Zip Code')"
                                                formControlName="zipCode"
                                                [MaxLength]="ZipCodeMaxLength"
                                                [Appearance]="'outline'">
                        </enterprise-text-input>
                        <div id="login-form-button-container" class="login-button-container">
                            <button id="login-submit"
                                    mat-raised-button
                                    type="submit"
                                    class="mat-flat-button mat-primary btn-sm">
                                    <mat-icon>arrow_forward_ios</mat-icon>
                                    Next
                            </button>
                        </div>
                        <p class="login-footer-container">
                            <span>
                                    The Web Questionnaire is not directed toward persons under 18 years of age. We do not knowingly market to or collect any personal information from children
                                    under the age of 18 through the internet. If you are under 18, you are not permitted to submit any personal information to us through this site.
                                    If you provide information to us through the Web Questionnaire, you represent that you are 18 years of age or older.
                            </span>
                        </p>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>
